import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { CheckIcon } from 'lucide-react';
const items = [{
  name: 'Guía Completa + 500 Recetas',
  value: '$49.99'
}, {
  name: 'Bono #1: Guía para Aliviar las Molestias de los Dientes',
  value: '$19.99'
}, {
  name: 'Bono #2: Guía del Sueño a Través de la Alimentación',
  value: '$29.99'
}, {
  name: 'Bono #3: Guía del Destete Sin Sufrimiento',
  value: '$34.99'
}];
export function OfferStack() {
  return <section className="py-10 md:py-20 px-5 md:px-6 bg-[#F0F8FB]" data-id="element-101">
      <div className="max-w-3xl mx-auto" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white p-5 md:p-12 rounded-3xl shadow-xl border-2 border-[#F9A8B7]" data-id="element-103">
          <h2 className="text-2xl md:text-5xl font-bold text-center text-[#2D1F1A] mb-6 md:mb-10 leading-tight tracking-tight" data-id="element-104">
            LO QUE TE LLEVAS <em className="text-[#F9A8B7] not-italic" data-id="element-105">HOY</em>
          </h2>
          <div className="space-y-2 md:space-y-4 mb-6 md:mb-8" data-id="element-106">
            {items.map((item, index) => <div key={index} className="flex items-center justify-between py-2.5 md:py-3 border-b border-gray-100 last:border-0 gap-3" data-id="element-107">
                <div className="flex items-center gap-2 md:gap-3 min-w-0" data-id="element-108">
                  <div className="bg-[#A9D7E2]/30 p-1 rounded-full flex-shrink-0" data-id="element-109">
                    <CheckIcon className="w-3.5 h-3.5 md:w-4 md:h-4 text-[#6FB8C9]" strokeWidth={3} data-id="element-110" />
                  </div>
                  <span className="font-semibold text-sm md:text-lg text-gray-800 leading-tight" data-id="element-111">
                    {item.name}
                  </span>
                </div>
                <span className="text-gray-400 line-through font-medium text-sm md:text-base flex-shrink-0" data-id="element-112">
                  {item.value}
                </span>
              </div>)}
          </div>
          <div className="bg-[#FFF1F4] p-5 md:p-8 rounded-2xl text-center mb-6 md:mb-8 border-2 border-dashed border-[#F9A8B7]/40" data-id="element-113">
            <p className="text-base md:text-xl text-gray-500 mb-2 md:mb-3 italic" data-id="element-114">
              Valor Total Real:{' '}
              <span className="line-through font-bold" data-id="element-115">$134.96</span>
            </p>
            <p className="text-4xl md:text-7xl font-bold text-[#F9A8B7] tracking-tight leading-none" data-id="element-116">
              HOY PAGAS: $14.99
            </p>
          </div>
          <div className="text-center space-y-3 md:space-y-4" data-id="element-117">
            <Button className="w-full text-lg md:text-xl py-4 md:py-5" data-id="element-118">
              AGREGAR AL CARRITO
            </Button>
            <p className="text-xs md:text-base text-gray-600 italic" data-id="element-119">
              <span className="font-bold not-italic text-[#2D1F1A]" data-id="element-120">
                Pago único.
              </span>{' '}
              Sin suscripciones.{' '}
              <span className="underline decoration-[#A9D7E2] decoration-2 underline-offset-2" data-id="element-121">
                Acceso de por vida.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}